// SVG Stroke Color Updater
// This utility helps update all SVG stroke="#000" to use CSS variables

export const updateSVGStrokes = () => {
  // Function to update SVG stroke attributes
  const updateStrokeAttributes = () => {
    const strokeElements = document.querySelectorAll('svg[stroke="#000"], path[stroke="#000"], line[stroke="#000"], rect[stroke="#000"], circle[stroke="#000"], polygon[stroke="#000"], polyline[stroke="#000"]');
    
    strokeElements.forEach(element => {
      if (element.getAttribute('stroke') === '#000') {
        element.setAttribute('stroke', 'var(--stroke-color)');
      }
    });
  };

  // Function to update inline styles with stroke
  const updateInlineStrokeStyles = () => {
    const elements = document.querySelectorAll('[style*="stroke: #000"], [style*="stroke:#000"]');
    
    elements.forEach(element => {
      const style = element.getAttribute('style');
      if (style) {
        let newStyle = style
          .replace(/stroke:\s*#000/g, 'stroke: var(--stroke-color)')
          .replace(/stroke:\s*#000/g, 'stroke: var(--stroke-color)');
        
        element.setAttribute('style', newStyle);
      }
    });
  };

  // Run updates
  updateStrokeAttributes();
  updateInlineStrokeStyles();
};

// Auto-run when DOM is ready
if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', updateSVGStrokes);
  
  // Also run when theme changes
  document.addEventListener('theme-changed', updateSVGStrokes);
}

export default updateSVGStrokes; 